import { render, staticRenderFns } from "./EndCapture.vue?vue&type=template&id=2b444f8e&scoped=true&"
import script from "./EndCapture.vue?vue&type=script&lang=js&"
export * from "./EndCapture.vue?vue&type=script&lang=js&"
import style0 from "./EndCapture.vue?vue&type=style&index=0&id=2b444f8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b444f8e",
  null
  
)

export default component.exports